import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'nova-delegation-set-inactive-dialog',
    standalone: true,
    imports: [MatButtonModule, MatDialogModule],
    templateUrl: './delegation-set-inactive-dialog.component.html',
    styleUrls: ['./delegation-set-inactive-dialog.component.scss']
})
export class DelegationSetInactiveDialogComponent {
    isCurrent: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) private readonly _data: { isCurrent: boolean },
        private readonly _matDialogRef: MatDialogRef<DelegationSetInactiveDialogComponent>
    ) {
        this.isCurrent = this._data.isCurrent;
    }

    get dialogTitle() {
        return this.isCurrent ? 'End Coverage' : 'Cancel Coverage';
    }

    get dialogBody() {
        return this.isCurrent
            ? 'Are you sure you want to end this coverage?'
            : 'Are you sure you want to cancel this upcoming coverage?';
    }

    get dialogConfirm() {
        return this.isCurrent ? 'Yes, end coverage' : 'Yes, cancel coverage';
    }

    setDelegationToInactive(): void {
        this._matDialogRef.close(true);
    }
}
